export const Icons = {
    house: 'icon-house',
    calendar: 'icon-calendar-range',
    company: 'icon-building-2',
    establishments: 'icon-map-pin-house',
    persons: 'icon-users',
    warehouse: 'icon-warehouse',
    settings: 'icon-settings',
    holdings: 'icon-hotel',
    companies: 'icon-building',
    departments: 'icon-users-round',
    costCenter: 'icon-wallet',
    dashboard: 'icon-layout-dashboard',
    handIcons: 'icon-hand-coins',
    summary: 'icon-clipboard-list',
    guide: 'icon-file-text',
    fileText: 'icon-file-text',
    document: 'icon-file-type',
    list: 'icon-layout-list',
    transfers: 'icon-arrow-up-down',
    chevronLeft: 'icon-chevron-left',
    chevronRight: 'icon-chevron-right',
    chevronDown: 'icon-chevron-down',
    menu: 'icon-menu',
    search: 'icon-search',
    shield: 'icon-shield',
    normative: 'icon-book-minus',
    landmark: 'icon-landmark',
    water: 'icon-droplets',
    database: 'icon-database',
    reports: 'icon-file-chart-column',
    monitor: 'icon-monitor',
    reportTemplates: 'icon-folder-kanban',
    screens: 'icon-app-window',
    graphs: 'icon-chart-pie',
    screenTypes: 'icon-tablet-smartphone',
    supply: 'icon-shopping-basket',
    fuel: 'icon-fuel',
    gauge: 'icon-circle-gauge',
    shirt: 'icon-shirt',
    archive: 'icon-archive',
    calendarDays: 'icon-calendar-days',
    bubbles: 'icon-bubbles',
    productiveCycle: 'icon-circle-dashed',
    tools: 'icon-wrench',
    consumptionSource: 'icon-car-front',
    power: 'icon-zap',
    refresh: 'icon-refresh-cw',
    silo: 'icon-ticket-minus',
    maintenance: 'icon-hammer',
    environment: 'icon-leaf',
    recycle: 'icon-recycle',
    check: 'icon-check',
    check2: 'icon-check-check',
    alert: 'icon-circle-alert',
    info: 'icon-info',
    circle: 'icon-circle',
    statement: 'icon-bookmark',
    new: 'icon-circle-plus',
    destination: 'icon-trending-up-down',
    residue: 'icon-trash',
    residue2: 'icon-trash-2',
    footprints: 'icon-footprints',
    activity: 'icon-activity',
    logistic: 'icon-map-pinned',
    transport: 'icon-truck',
    drivers: 'icon-ship-wheel',
    documents: 'icon-folder-open',
    plus: 'icon-plus',
    userCog: 'icon-user-cog',
    policy: 'icon-scroll-text',
    idCard: 'icon-id-card',
    layoutGrid: 'icon-layout-grid',
    payment: 'icon-circle-dollar-sign',
    checkCircle: 'icon-circle-check',
    pin: 'icon-pin',
    fileBadge: 'icon-file-badge',
    tags: 'icon-tags',
    waves: 'icon-waves',
    droplet: 'icon-droplet',
    toggleLeft: 'icon-toggle-left',
    toggleRight: 'icon-toggle-right',
    ruler: 'icon-ruler',
    ruler2: 'icon-move-vertical',
    compass: 'icon-compass',
    map: 'icon-map',
    zap: 'icon-zap',
    mapPin: 'icon-map-pin',
    cloudUpload: 'icon-cloud-upload',
    history: 'icon-history',
}